export default __webpack_public_path__ + "static/admin-brush-ef5a5473.svg";